import { useMutation } from '@tanstack/react-query';
import { POST, POST_UPDATE_PRODUCT } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';
import { navigateTo } from '../../../../utils/navigation';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import { updateProduct } from '../../../../resources/payload';

export const useUpdateProduct = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (value) => {
      const payload = updateProduct(value);
      const response = await POST(POST_UPDATE_PRODUCT(), payload);
      return response;
    },
    onSuccess: (response) => {
      openAlert({ type: 'success', message: response?.message, model: 'message' });
      setTimeout(() => {
        navigateTo({ pathname: ROUTES_PATH.ROUTE_CLIAM_LIST.PATH });
      }, 1000);
    },
    onError: (error) => {
      openAlert({ type: 'error', message: error?.message });
    },
  });
  return { mutate, loading: isPending };
};
